import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { ConfirmDialog } from '../../components/ConfirmDialog.js';
import { Field } from '../../components/Field.js';
import { apiRequest } from '../../lib/api.js';

/**
 * «Riapri l'anno» (3.10): extraordinary, the administrator only, with the
 * reason and the year written again; the closure stays in the history.
 */
export function ReopenYearDialog({
  year,
  onClose,
  onDone,
}: {
  year: number;
  onClose: () => void;
  onDone: () => Promise<void> | void;
}) {
  const [reason, setReason] = useState('');
  const [confirm, setConfirm] = useState('');
  const reopen = useMutation({
    mutationFn: () =>
      apiRequest<void>(`/treasury/year-closures/${year}/reopen`, {
        method: 'POST',
        body: { reason: reason.trim(), confirm: Number(confirm) },
      }),
    onSuccess: onDone,
  });
  return (
    <ConfirmDialog
      title={`Riaprire il ${year}?`}
      confirmLabel="Riapri"
      busy={reopen.isPending}
      disabled={reason.trim().length < 10 || confirm !== String(year)}
      error={reopen.error?.message}
      onConfirm={() => reopen.mutate()}
      onCancel={onClose}
    >
      <p className="small">
        È un’operazione straordinaria. L’anno torna modificabile finché non lo richiudi; la
        fotografia di questa chiusura resta conservata e la riapertura va nel Registro attività.
      </p>
      <Field label="Motivo (almeno 10 caratteri)">
        <textarea
          rows={3}
          maxLength={500}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
      </Field>
      <Field label={`Scrivi ${year} per confermare`}>
        <input value={confirm} onChange={(event) => setConfirm(event.target.value)} />
      </Field>
    </ConfirmDialog>
  );
}
